import styled, { css } from 'styled-components'

export const Title = styled.h1`
    font-size: ${props => props.size || '30px'};
    line-height: ${props => props.lineHeight || '24px'};
    color: ${props => props.color || props.theme.colors.text.secondaryText};
    font-weight: ${props => props.fontWeight || 600};
    margin: ${props => props.margin || '0'};
    text-align: ${props => props.align || 'left'};
    font-style: ${props => (props.italic ? 'italic' : 'normal')};
    ${props => (props.mobileSize || props.mobileAlign) && css`
        @media (max-width: ${p => p.theme.sizes.breakPoints.small}) {
            font-size: ${p => p.mobileSize || p.size || '30px'};
            text-align: ${p => p.mobileAlign || p.align || 'left'};
        }
    `}
`;
export const SubTitle = styled.h1`
    font-size: ${props => props.size || '14px'};
    line-height: ${props => props.lineHeight || '16px'};
    color: ${props => props.color || props.theme.colors.text.primaryText};
    font-weight: ${props => props.fontWeight || 400};
    margin: 0;
`;

export const Text1Bold = styled.p`
    font-size: ${props => props.size || '14px'};
    line-height: ${props => props.lineHeight || '16px'};
    color: ${props => props.color || props.theme.colors.text.primaryText};
    font-weight: ${props => props.fontWeight || 600};
    text-align: ${props => props.align || 'left'};
    margin: 0;
`;


export const Text1 = styled.p`
    font-size: ${props => props.size || '20px'};
    line-height: ${props => props.lineHeight || '24px'};
    color: ${props => props.color || props.theme.colors.brand.blueOmint};
    font-weight: ${props => props.fontWeight || 600};
    margin: 0;
    text-decoration: ${props => props.textDecoration ? props.textDecoration : 'none'};
    text-align: ${props => props.align || 'left'};

`;

export const Text2 = styled.p`
    font-size: ${props => props.size || '16px'};
    line-height: ${props => props.lineHeight || '16px'};
    color: ${props => props.color || props.theme.colors.brand.blueOmint};
    font-weight: ${props => props.fontWeight || 400};
    margin: ${props => props.margin || '0'};
    text-align: ${props => props.align || 'left'};
    font-style: ${props => (props.italic ? 'italic' : 'normal')};
    @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
        font-size: ${props => props.mobileSize || props.size || '16px'};
        text-align: ${props => props.mobileAlign || props.align || 'left'};
    }
`;

export const LinkText = styled.a`
    font-size: ${props => props.size || '16px'};
    line-height: ${props => props.lineHeight || '16px'};
    color: ${props => props.color || props.theme.colors.brand.blueOmint};
    font-weight: ${props => props.fontWeight || 400};
        text-decoration: ${props => props.textDecoration || 'underline'};
        display: inline-flex;
        cursor: pointer;
        &:hover {
            text-decoration: ${props => props.textDecoration || 'underline'};
        }
`;

export const NavText = styled.span`
	font-size: 0.75rem;
	font-weight: 500;
`